<template>
    <div id="foot-bar">
       <div class="f-between">
        <div class="tip" >
            Powered in 2024
        </div>
        <div class="hello" v-if="name!=''">
            您好，{{name}}
            <a-button  class="quit" type="text" @click="exit()"><poweroff-outlined />退出</a-button>
        </div>

       </div>
    </div>
    
   
</template>

<script>
    import { mapActions } from "vuex"
    
    export default {
        name: 'footBar',
        data() {
            return {
                name:""

            }
        },
        created() {
            this.name = localStorage.getItem('name') || ''
  

        }, 
        methods:{
        ...mapActions([
          'auth_validate',
          'auth_logout'
        ]),

            exit(){

                let token = localStorage.getItem('t') || 'xx'
                let params = {}

                params.token = token

                this.auth_logout(params)
                .then((dt) => {
                    
                    localStorage.setItem('t', '')
                    localStorage.setItem('name', '')
                    
                    //清空计时器
                    clearInterval(this.timer);

                    this.$router.push('/')

                })
                .catch((dt) => {
                    
                    localStorage.setItem('t', '')
                    localStorage.setItem('name', '')

                    this.$router.replace({
                        name: '/'
                    })
                    
                });

                },
                check_token(){
                
                let token = localStorage.getItem('t') || ''

                if (token){
                    let params = {}
                    
                    params.token = token

                    this.auth_validate(params)
                    .then((dt) => {
                        if (dt=="valid"){
                        this.$router.replace('/home')
                        
                        }
                        else{
                        this.disabled = false
                        }
                    })
                    .catch((dt) => {
                        //nothing
                        
                        });

                    }
                
                else{
                    this.disabled = false
                }
                
            }

        }
    }
    
    

</script>
    
<style>
#foot-bar {
    bottom:0;
    z-index:999;
    position: fixed;
    width: 100%;
    height: 40px;
    background-color: #c6e2ff;
    border-top:1px transparent solid;
    border-image:linear-gradient(to right,#FFCCCC,#413b79) 1 10;
}

.tip{
    cursor: default;
    margin:0 20px;
    line-height:40px;
}

.hello{
    cursor: default;
    float: right;
    margin:0 20px;
    line-height:40px;
}

.quit:hover span{
    color:red;
}




</style>